// extracted by mini-css-extract-plugin
export default {"control":"OP1WebFrameWindowControl_control__3q6nR"};